import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { WizardCGOComponent } from './wizard-cgo.component';


//import { BlankComponent } from '../pagina/blank/blank.component';
//import { CardedFullWidth2Component } from '../pagina/carded/full-width-2/full-width-2.component';

/// TESTING
import { WizardCertificarRutasModule } from './certificar/certificar.rutas.module';
import { WizardMedirRutasModule } from './medir/medir.rutas.module';
import { WizardPulseRutasModule } from './pulse/pulse.rutas.module';
import { WizardFocusRutasModule } from './focusa/focus.rutas.module';
// import { WizardLeaderGoRutasModule } from './leaderGo/leaderGo.rutas.module';

//nuevos CERTIFICAR
import { WizardCertificarT1RutasModule } from './certificar/tipo_1/tipo_1.rutas.module';
import { WizardCertificarT2RutasModule } from './certificar/tipo_2/tipo_2.rutas.module';
//nuevos medir
import { WizardMedirT1RutasModule } from './medir/tipo_1/tipo_1.rutas.module';
import { WizardMedirT2RutasModule } from './medir/tipo_2/tipo_2.rutas.module';
import { WizardMedirT3RutasModule } from './medir/tipo_3/tipo_3.rutas.module';
import { WizardMedirT4RutasModule } from './medir/tipo_4/tipo_4.rutas.module';
import { WizardMedirT5RutasModule } from './medir/tipo_5/tipo_5.rutas.module';
import { WizardMedirT6RutasModule } from './medir/tipo_6/tipo_6.rutas.module';
import { SurveyProductComponent } from './survey-product/survey-product.component';
import { ModalWizardComponent } from 'app/main/wizard-cgo/modal-wizard/modal-wizard.component';
import { FlexLayoutModule } from '@angular/flex-layout';


// RUTAS
//import { routes } from './wizard-cgo.rutas';

/*const routes = [
    {
        path     : 'cgoCert',
        component: WizardCGOComponent,
        children: [
            { path: 'pag1', component: BlankComponent },
            { path: 'pag2', component: CardedFullWidth2Component },
            { path: 'pag3', component: BlankComponent },
            { path: 'pag4', component: CardedFullWidth2Component }
        ]
    }
];*/

@NgModule({
  declarations: [WizardCGOComponent, SurveyProductComponent,ModalWizardComponent],
  imports     : [
      //RouterModule.forChild(routes),
      //routes,
      RouterModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      MatTooltipModule,
      MatStepperModule,
      CdkStepperModule,
      TranslateModule,
      FuseSharedModule,
      FuseSidebarModule,
      WizardCertificarRutasModule,
      WizardMedirRutasModule,
      WizardPulseRutasModule,
      WizardFocusRutasModule,
      // WizardLeaderGoRutasModule,
      WizardMedirT1RutasModule,
      WizardMedirT2RutasModule,
      WizardMedirT3RutasModule,
      WizardMedirT4RutasModule,
      WizardMedirT5RutasModule,
      WizardMedirT6RutasModule,
      WizardCertificarT1RutasModule,
      WizardCertificarT2RutasModule,
      FlexLayoutModule,
      MatCheckboxModule,
  ],
  exports     : [
      WizardCGOComponent
  ],
  entryComponents: [ModalWizardComponent]
})
export class WizardCGOModule { }
